import { PRESET_SCHEMA_VERSION } from "./capabilities.js";
import { PARAM_NAMES, PARAM_RANGES } from "./params.js";
export function defaultModulator(index, shape = "sine") {
    const frequencyDefaults = {
        1: 1,
        2: 2,
        3: 0.5,
        4: 4,
    };
    return {
        index,
        shape: { kind: "preset", shape },
        timing: { mode: "free_hz", frequencyHz: frequencyDefaults[index] ?? 1 },
        trigger: "note_retrigger",
        phase: 0,
        fadeSeconds: 0,
        delaySeconds: 0,
        stereoOffset: 0,
    };
}
export function createEmptyPreset(name = "Init") {
    const params = {};
    for (const key of PARAM_NAMES) {
        params[key] = PARAM_RANGES[key].default;
    }
    const lfoShapes = {
        1: "sine",
        2: "triangle",
        3: "square",
        4: "saw",
        5: "sine",
        6: "sine",
        7: "sine",
        8: "sine",
    };
    return {
        schemaVersion: PRESET_SCHEMA_VERSION,
        name,
        style: "other",
        comments: "",
        params,
        modulations: [],
        lfoShapes,
        modulators: [1, 2, 3, 4, 5, 6, 7, 8].map((index) => defaultModulator(index, lfoShapes[index] ?? "sine")),
        sequences: [],
        macros: [
            { index: 1, name: "MACRO 1", assignments: [] },
            { index: 2, name: "MACRO 2", assignments: [] },
            { index: 3, name: "MACRO 3", assignments: [] },
            { index: 4, name: "MACRO 4", assignments: [] },
        ],
        wavetables: {
            1: { kind: "basic", shape: "saw" },
            2: { kind: "basic", shape: "sine" },
            3: { kind: "basic", shape: "square" },
        },
    };
}
//# sourceMappingURL=model.js.map